module.exports = __webpack_public_path__ + "static/img/05.243f349.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/05.jpg
// module id = uy92
// module chunks = 18